import { Link } from 'react-router-dom';

export default function SpecialtiesSection() {
  return (
    <section className="py-20 md:py-0 bg-warm-100">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[560px]">
        {/* Left: Image */}
        <div className="relative overflow-hidden min-h-[400px] lg:min-h-[560px]">
          <img
            src="https://static.readdy.ai/image/b56ddf5676badcd01c30e06215815ec0/9ca8537e7d8614358917eafe713ae7ff.jpeg"
            alt="Sweet Celebrations signature cheesecake dessert"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-blush-500/30" />
          {/* Floating label */}
          <div className="absolute bottom-8 left-8 bg-white/95 rounded-xl px-5 py-3 backdrop-blur-sm">
            <p className="text-gold-600 text-xs uppercase tracking-widest font-semibold">Featured Creation</p>
            <p className="text-charcoal-800 font-serif text-lg">Signature Cheesecake</p>
          </div>
        </div>

        {/* Right: Content */}
        <div className="flex flex-col justify-center px-8 md:px-14 lg:px-16 py-16 lg:py-20 bg-cream-100">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-10 bg-gold-500" />
            <span className="text-gold-500 text-xs uppercase tracking-[0.25em] font-sans font-semibold">Our Specialty</span>
          </div>

          <h2 className="font-serif text-4xl md:text-5xl text-charcoal-800 leading-tight mb-6">
            Creativity Based on<br />
            <em className="italic text-blush-500">Your Imagination</em>
          </h2>

          <p className="text-warm-gray text-base md:text-lg leading-[1.9] mb-8 font-sans font-light max-w-lg">
            From elegant cakes to bite-sized desserts, Sweet Celebrations brings your ideas to life with creativity, detail, and delicious flavor. Whether it&apos;s a wedding, birthday, baby shower, or Tuesday — we make every celebration extraordinary.
          </p>

          <div className="flex flex-col gap-4 mb-10">
            {[
              'All sweet treats made to order',
              'Completely custom designs',
              'Flavors as unique as your vision',
              'Serving Lubbock & surrounding area',
            ].map((item) => (
              <div key={item} className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-blush-500 text-white flex-shrink-0">
                  <i className="ri-check-line text-xs" />
                </div>
                <span className="text-charcoal-700 text-sm font-sans">{item}</span>
              </div>
            ))}
          </div>

          <Link
            to="/custom-orders"
            className="inline-flex items-center gap-2 bg-blush-500 hover:bg-blush-600 text-white px-8 py-4 rounded-full font-sans font-semibold text-sm tracking-wide whitespace-nowrap self-start transition-all duration-200 hover:scale-105 cursor-pointer"
          >
            Start Your Custom Order
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
